class Constants {
    static noValue = "——";

    static systemModules = {
        PDP: "PDP",
        PLP: "PLP",
        BOM: "BOM",
        CART: "Cart",
        CHECKOUT: "CheckOut",
        Compare: "Compare",
        ADDTOCART: "AddToCart",
        ORDER: "Order",
        SuccessCheckout: "SuccessCheckout",
        ORDERDETAIL: 'OrderDetail'
    }

    static checkOutSteps = {
        ADDRESS_STEP: "address_step",
        METHOD_STEP: "method_step",
        PAYMENT_STEP: "payment_step"
    }

    static checkoutApiSteps = {
        Step1: "Step_1",
        Step2: "Step_2",
        Step3: "Step_3"
    }

    static taxExempt = {
        EXEMPT: "Exempt",
        OVERWRITE: "Overwrite",
        NONE: "None"
    }

    static cartSummary = {
        SUBTOTAL: "subTotal",
        ORDERTOTAL: "orderTotal",
    }
    static currencyType = {
        USD: "USD",
        CAD: "CAD",
        JPY: 'JPY'
    }

    static CartType = {
        SHOPPING: "Shopping",
        MYCART: "myCart"
    }
    static addressType = {
        BILL_TO: "BillTo",
        SHIP_TO: "ShipTo",
    }

    static countryCodes = ["JP", "PR", "US", "CN", "CA"]
    static countryNames = {
        "Japan": "JP",
    }

    static salesOrgC001 = 'C001';
    static salesOrgHK1E = 'HK1E'

    static numericPattern = /^[0-9-+()\/]*$/;
    static mobilePattern = /^[0-9\s()+\-.,]*[0-9]+[0-9\s()+\-.,]*$/;
    static onlyNumberPattern = /^[0-9]*$/;
    static companyNamePattern = /^[a-zA-Z0-9 ~!$%^&\-_=+{}\[\]|:<>.,||俊容洪šž辉季áí赵凯济同张丁弘ň()段超琼ğ康云宝öüélèáís*i陈华景å'ü@éø李金成JÃƒÂ¶rgłD´ŻÃ©|ÖMÃƒÆ’Ã‚Â¶Â¼hle#?]*$/;
    static onlyStringPattern = /^[a-zA-Z ]+$/;
    static avnetEmailPattern = /^([a-zA-Z0-9]+([$%._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([$%._-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/;
    static addressPattern = /^[A-Za-z0-9 &*#'_\\\-,.()\/]+$/;
    static alphaNumericPattern = /^[a-zA-Z0-9]*$/;
    static alphaNumericPatternWithSpace = /^[a-zA-Z0-9 ]*$/;
    static emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    static internalUsers = ["ebv.com", "avnet.eu", "silica.com", "avnet-abacus.eu", "abacus.co.uk",
        "avnet-embedded.eu", "avnet.com", "AVNETTIME.EU", "avnet-memec.eu", "avnet.abacus.eu", "softwebsolutions.com"]
    static zipCodePattern = /^[A-Za-z0-9 &*#'_\\\-,.ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßsLàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿĀāĂăĄąĆćĈĉĊċČčĎďĐđĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŁłŃńŅņŇňŉŊŋŌōŎŏŐőŒœŔŕŖŗŘřŚśŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŹźŻżŽžſ\/]+$/;
    static numericWithSpecialChar = /^[^a-z\s]{4,}$/
    static numericWithSpecialCharacters = /^[\d\W]+$/
    static apacCompanyNamePattern = /^[A-Za-z0-9 !$%&()+,.\-/<=>?@[\]^_{}]+$/
    static japanCompanyNamePattern = /^[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{}|;:,.<>/?`~]*$/
    static phoneNumberPattern = /^[0-9+\-*/()# ]+$/
    static apacFirstNamePattern = /^(?!.*["'\\])[\u4e00-\u9fffA-Za-z !@#$%^&*()_+\-=\[\]{};:,.<>/?`~|]+$/
    static japanFirstNamePattern = /^(?!.*["'\\])[A-Za-z !@#$%^&*()_+\-=\[\]{};:,.<>/?`~|]+$/
    static registerEmailPattern = /^(?!\.)([A-Za-z0-9_+\-'.]+)@[A-Za-z0-9\-]+(\.[A-Za-z]{2,})+$/
    static attnAsiaPattern = /^(?!.*["'\\])[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF A-Za-z0-9!@#$%^&*()_+\-=\[\]{};:,.<>/?|`~\s]+$/
    static attnJapanPattern = /^(?!.*["'\\])[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:,.<>/?|`~]+$/
    static softwarePartEmailPattern = /^(?![.])[A-Za-z0-9!$&#+%\-\/=?^*_{}|~.]+@[A-Za-z0-9\-]+\.[A-Za-z]{2,}$/
    static poNumberPattern = /^(?!.*[\*`:|~])[A-Za-z0-9\s!@#$%^&()\-_=+\[\]{};'",.<>/?\\]+$/
    static addressAsiaCheckoutPattern = /^(?!.*["'\\*\:`|~])[A-Za-z0-9 @[\]^_{}!#$%&()+,\-./;<=>? ]+$/
    static addressJapanCheckoutPattern = /^(?!.*["'\\])[A-Za-z0-9@[\]^_{}!#$%&()+,\-./;<=>? ]+$/

    static adminConsoleTab = {
        User: "users",
        Account: "accounts",
        Report: "reports",
        MainTab:"mainTab",
        BomDetails:"BomDetails"
    }
    static roles = [
        { value: 'ZI', label: 'ZI' },
        { value: 'ZX', label: 'ZX' },
        { value: 'ZU', label: 'ZU' }
    ]
    static userType = {
        INTERNAL: 'Internal',
        EXTERNAL: 'External'
    }

    static errorCode = {
        UserExist001: 'UserExist001',
        error404: '404',
        error402: '402',
        error422: '422',
        error400: '400',
        BOM001: 'BOM001',
    };

    static speedBoats = {
        apacAbbr: 'A',
        APAC: 'apac',
        japanAbbr: 'J',
        JAPAN: 'japan'
    }

    // value shold be which in available in "avUSerInfo"
    static userInfoKey = {
        USERNAME: "UserName",
        SPEEDBOAT: "speedboat",
        USERID: "userID",
        EMAIL: "email",
        BILLCOUNTRYCODE: "billToCountryCode",
        ACCOUNTNUMBER: "accountNumber",
        ACCOUNTNAME: "accountName",
        SPEEDBOATDESCRIPTION: "speedboatDescription",
        ROLES: "roles",
        SPEEDBOATNAME: "speedboatName",
        SALESORG: "salesOrg",
        CREDITRISK: "creditRisk",
        ORDERBLOCK: "orderBlock",
        DEFAULTSHIPTO: "defaultShipTo",
        CURRENTSHIPTO: "currentShippingAddress",
        ISADMIN: "isAdmin"
    }

    static homePageAllTabs = {
        PRODUCT: {
            tabHeader: "Products",
            countTab: "productCount",
            abbr: "PLT"
        },
        NPI: {
            tabHeader: "New Product Information",
            contentType: 'NPI',
            content: "NPI",
            countTab: "npiCount",
            abbr: "NPIT"
        },
        CONTENT: {
            tabHeader: "Content",
            countTab: "allContentCount",
            abbr: "CNT"
        },
        ALLCONTENT: {
            tabHeader: "All Content",
            contentType: 'All',
            content: "AllContent",
            countTab: "allCount",
            abbr: "ALCT"
        },
        ARTICLE: {
            tabHeader: "Articles",
            contentType: 'articles',
            content: "Articles",
            countTab: "articleCount",
            abbr: "ACL"
        },
        EVENT: {
            tabHeader: "Events",
            contentType: 'events',
            content: "Events",
            countTab: "eventCount",
            abbr: "EVT"
        },
        SITE: {
            tabHeader: "Site pages",
            contentType: 'sitePages',
            content: "SitePage",
            countTab: "siteCount",
            abbr: "SITE"
        },
        VIDEO: {
            tabHeader: "Videos",
            contentType: 'video',
            countTab: "videoCount",
            abbr: "VDO",
            pageType: "Brightcove-Videos"
        },
        DOCUMENT: {
            tabHeader: "Documents",
            countTab: "documentCount",
            abbr: "DCT"
        }
    };

    static bomDetailPageTabs = {
        BomExactMatchTable: {
            tabHeader: "Exact Match",
            content: "BomExactMatchTable",
            api_fetch_type: "Exact"
        },
        BomMultipleMatchTable: {
            tabHeader: "Multiple Match",
            content: "BomMultipleMatchTable",
            api_fetch_type: "Multiple"
        },
        BomNoMatchTable: {
            tabHeader: "No Match",
            content: "BomNoMatchTable",
            api_fetch_type: "NoMatch"
        },
    }

    static BomPages = {
        CreateBom: { param_value: 'CreateBom' },
        BomTabsList: { param_value: 'BomTabsList' },
        BomRematch: { param_value: 'BomRematch' },
        BomProductListing: { param_value: 'BomProductListing' },
        BomDetailById: { param_value: 'BomDetailById' },
    };


    static ProfileTab = {
        ProfileInfo: "ProfileInformation",
        AddressBook: "AddressBook",
        Contact: "MyAvnetContacts",
    }


    static siteUser = {
        GUEST: "Guest",
        WEB: "Web",
        CORE: "Core"
    }

    static LifeCycleRisk = {
        LOW: "Low",
        MED: "Med",
        HIGH: "High"
    }

    static DescriptionLength = {
        More: "more",
        Less: "less"
    }

    static QuantityAction = {
        Minus: "minus",
        Plus: "plus"
    }

    static PreferenceType = {
        Default_Account: "Default_Account",
        Default_ShipTo: "Default_ShipTo",
        Default_BillTo: "Default_BillTo",
        Default_Carrier: "Default_Carrier",
        Download_Bom_Columns: "Download_Bom_Columns",
        Download_Forecast_FileType: "Download_Forecast_FileType"
    }

    static paymentType = {
        CreditCard: 'CreditCard',
        AvnetCredit: 'AvnetCreditLine',
        WireTransfer: 'WireTransfer',
        DefaultPaymentTerm: 'DefaultPaymentTerms',
        Alipay: "AliPay",
        ChinaUnionPay: "UnionPay"
    }
    static shippingCarrierType = {
        MANUAL: 'MANUAL',
        AVNET: 'AVNET',
        FREESHIP: 'FreeShip',
        INCOTERM: "Incoterm"
    }
    static avnetCarrierType = {
        FEDEX: 'fedEx',
        UPS: 'ups',
        DHL: 'dhl',
    }

    static AdminComplianceOptions = {
        orderNumber: "Web Order Number",
        customerName: "Customer Name",
    }

    static AdminOrderOptions = {
        WebOrderNumber: "Web Order Number",
        SalesOrderNumber: "Sales Order Number",
        OrderState: "Order State",
        AccountNumber: "Account Number",
        CustomerLoginId: "Customer Login ID",
    }

    static AdminOrderState = {
        PendingAuth: "Pending Auth",
        Ready: "Ready",
        Sent: "Sent",
        Confirmed: "Confirmed",
        Rejected: "Rejected",
        Error: "Error",
        Hold: "Hold",
        Blocked: "Blocked",
    }

    static ReprocessEligibleStatus = ["PendingAuth", "Blocked", "Failed", "Rejected"]

    static TaxExemptFormURL = 'https://www.avnet.com/wcsstore/AvnetSAS/version_v06072024/StaticContent/Tax_Template.pdf'

    static ACCOUNTINACTIVE = "accountInactive"
    static INVALIDSUPPLIER = "invalidSupplier"
    static INTERNALUSER = "internalUser"
    static INVALIDMANUFACTURER = "invalidManufacturer"
    static RESTRICTEDCOUNTRY = "restrictedCountry"
    static INVALIDITEMPRICE = "invalidItemPrice"
    static paymentError = "paymentError"
    static shipToPOBox = "shipToPOBox"

    static Restricted_Countries = ['UA', 'RU', 'BY']

    static OrderPages = {
        OrderHistory: {
            name: 'OrderHistory',
            param_value: 'OrderHistory'
        },
        OrderDetail: {
            name: 'OrderDetail',
            param_value: 'OrderDetail'
        }
    }

    static OrderDetailTabList = {
        BY_SHIPMENT: {
            name: 'BY SHIPMENT',
            param_value: 'BY_SHIPMENT'
        },
        BY_LINE_ITEMS: {
            name: 'BY LINE ITEMS',
            param_value: 'BY_LINE_ITEMS'
        },
    };

    static plpTabParam = "__c_HomeTabList"

    static LanguageCodes = {
        "zh-TW": "zh-TW", // Traditional Chinese (Taiwan)
        "zh-CN": "zh-CN", // Simplified Chinese (Mainland China)
        "en": "en",       // English
        "ja-JP": "ja-JP", // Japanese (Japan)
        "en-US": "en-US"
    };

    static ProductDataObj = {
        "zh-TW": "Traditional_Chinese_Data", // Traditional Chinese (Taiwan)
        "zh-CN": "Simplified_Chinese_Data", // Simplified Chinese (Mainland China)
        "en": "English_Data",       // English
        "ja-JP": "Japanese_Data", // Japanese (Japan)
        "en-US": "English_Data"
    };
    
    static CognitiveSearchFieldConfig = {
        FamilyName: 'FamilyName',
        ManufacturerName: 'ManufacturerName',
        flagFacets: 'flagFacets',
        Categories: 'categories',
        attributes: 'attributes',
        normal: 'normal'
    };

    static countryCodesForFarnalElement = ["AU","NZ","CN","HK","IN","KR","MY","PH","SG","TW","TH"];
    static SELECTED_APAC_CURRENCY = 'selectedCurrencyApac'
    static SELECTED_JAPAN_CURRENCY = 'selectedCurrencyJapan'

    static UserRoles = {
        ZC: "Customer Service",
        ZA: "Online Admin"
    }

    static PRIMARY = 'PRIMARY'
    static SALES_PERSON = 'Sales Person'

    static orderStatus = {
        Shipment: "Shipment",
        Shipped: "Shipped",
        PartiallyShipped: "Partially Shipped",
        OrderInProcess: "Order in Process",
        Cancelled: "Cancelled",
        NotYetShipped: "Not Yet Shipped",
        OrderReceived: "Order Received"
    }
    
    static AnalyticsEvents = {
        INTERNAL_SEARCH_COMPLETED: 'internalSearchCompleted',
        TYPEHEAD_SEARCH: 'typeheadSearch',
        SEARCH_FILTER_APPLIED: 'searchFiltersApplied',
        BOM_FILE_UPLOAD: 'bomFileUpload',
        BOM_RENAME: 'renameBOM',
        BOM_OPENED: 'bomOpened',
        BOM_QUICKLY_PART: 'bomQuicklyAddPart',
        BOM_EMAIL: 'emailBOM',
        CREATE_BOM: 'createBOM',
        ADD_TO_BOM: 'addToBOM',
        BOM_SELECTION_MULTIPLE_RESOLVED: 'bomProdSelectionMultipleResolved',
        BOM_REMOVE_MULTIPLE_RESOLVED: 'bomProdRemoveMultipleResolved',
        BOM_PRODUCT_REMOVAL: 'bomProductRemoval',
        BOM_NO_MATCH_RESOLVED: 'bomNoMatchesResolved',
        BOM_REMOVE_NO_MATCH_RESOLVED: 'bomProdRemoveNoMatchesResolved',
        BOM_ADD_ITEM_TO_CART: 'miAddItemBomToCart',
        PRODUCT_VIEW: 'productView',
        ADD_TO_CART: 'addToCart',
        CHECKOUT_STEP_1: 'checkoutStep1',
        CHECKOUT_STEP_2: 'checkoutStep2',
        CHECKOUT_STEP_3: 'checkoutStep3',
        CART_OPEN: 'cartOpen',
        CART_VIEW: 'cartView',
        CART_REMOVAL: 'cartRemoval',
        CART_CHECKOUT: 'cartCheckout',
        PURCHASE: 'purchase',
        DOWNLOADS: 'downloads',
        EXPORTS: 'exports',
        BOM_DOWNLOAD: 'miBomDownload',
        ERROR_DETAILS: 'errorDetails',
        FORM_START: 'formStart',
        FORM_SUBMISSION: 'formSubmission',
        REGISTRATION_START: 'registrationStart',
        REGISTRATION_COMPLETE: 'registrationComplete',
        CTACLICK: 'ctaClick',
    }

    static UniversalSearchTabType = {
        MANUFACTURERS: 'Manufacturers',
        CATEGORIES: 'Categories',
        NEW_PRODUCT_INFORMATION: 'New Product Information',
        DOCUMENTS: 'Documents',
        ARTICLES: 'Articles',
        EVENTS: 'Events',
        SITEPAGES: 'Site Pages',
        VIDEOS: 'Videos'
    }

    static paymentMode = {
        ALIPAY: "ALIPAY",
        CHINAPAY: "CHINAPAY",
        CC: "CC",
        Eximbay: "Eximbay"
    }

    static userRoles = {
        ZB: 'ZB',
        ZX: 'ZX'
    }
}

export default Constants;